import { useApiFetcherSWR } from "hooks/SwrCustom";


const API_ENDPOINT = {
    GET_GENERAL_SETTING: {
        url: "general-settings",
        method: "get",
    },
    PATCH_GENERAL_SETTINGS: {
        url: "general-settings",
        method: "patch",
    },

    POST_POWER_BI_SAVE_LINK: {
        url: "power-bi/save-link",
        method: "post",
    },

    POST_TEST_EMAIL_OR_SMS: {
        url: "test-emails-or-sms",
        method: "post",
    },
    POST_TOGGLE_EMAIL: {
        url: 'toggle-scheduled-job',
        method: 'post'
    },
    POST_TOGGLE_SMS: {
        url: 'toggle-push-notification',
        method: 'post'
    },
    SCHEDULED_EMAIL_JOBS: {
        url: 'scheduled-jobs',
        method: 'get'
    },
    SCHEDULED_SMS_JOBS: {
        url: "scheduled-push-notifications",
        method: "get"
    }

};

export const useGeneralSettings = () =>
    useApiFetcherSWR(API_ENDPOINT.GET_GENERAL_SETTING);

export const useUpdateGeneralSettings = () =>
    useApiFetcherSWR(API_ENDPOINT.PATCH_GENERAL_SETTINGS);

export const useSavePowerBiLink = () =>
    useApiFetcherSWR(API_ENDPOINT.POST_POWER_BI_SAVE_LINK);

export const useTestEmailOrSms = () =>
    useApiFetcherSWR(API_ENDPOINT.POST_TEST_EMAIL_OR_SMS);

export const useToggleEmail = () =>
    useApiFetcherSWR(API_ENDPOINT.POST_TOGGLE_EMAIL);
export const useToggleSms = () =>
    useApiFetcherSWR(API_ENDPOINT.POST_TOGGLE_SMS);

export const useScheduledEmailJobs = () =>
    useApiFetcherSWR(API_ENDPOINT.SCHEDULED_EMAIL_JOBS);

export const useScheduledSmsJobs = () =>
    useApiFetcherSWR(API_ENDPOINT.SCHEDULED_SMS_JOBS);